import { render } from "./BannerSwiper.vue?vue&type=template&id=f68ff5d4&scoped=true"
import script from "./BannerSwiper.vue?vue&type=script&lang=js"
export * from "./BannerSwiper.vue?vue&type=script&lang=js"

import "./BannerSwiper.vue?vue&type=style&index=0&id=f68ff5d4&scoped=true&lang=css"

import exportComponent from "/Users/taesungkim/Git/parnas-app-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f68ff5d4"]])

export default __exports__